import React, { useState } from "react";
import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Input } from "../../../../../design/input";
import { Intake } from "../../../../../models/Intake";

interface Props {
  formData: Omit<
    Intake,
    "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
  >;
  setFormData: React.Dispatch<
    React.SetStateAction<
      Omit<
        Intake,
        "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
      >
    >
  >;
  onBack: () => void;
  onStepComplete: () => void;
}

const OnboardingRelationshipDatesStep: React.FC<Props> = ({
  onBack,
  onStepComplete,
  formData,
  setFormData,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  const submitEnabled = () => {
    switch (formData.marriageStatus) {
      case "married":
        return formData.dateOfMarriage && formData.locationOfMarriage;
      case "separated":
        return (
          formData.dateOfMarriage &&
          formData.locationOfMarriage &&
          formData.dateOfSeparation
        );
      case "divorced":
        return (
          formData.dateOfMarriage &&
          formData.locationOfMarriage &&
          formData.dateOfSeparation &&
          formData.dateOfDivorce
        );
    }
  };

  return (
    <OnboardingContainer title={"Relationship Dates"}>
      <>
        <p className="mb-6 text-gray-700">
          Help us with a few important dates about your relationship.
        </p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <Field>
            <Label>When did you get married?</Label>
            <Input
              type="date"
              value={
                formData.dateOfMarriage
                  ? formData.dateOfMarriage.toISOString().split("T")[0]
                  : ""
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  dateOfMarriage: e.target.value
                    ? new Date(e.target.value)
                    : undefined,
                })
              }
              required
            />
          </Field>

          <Field>
            <Label>In what city and state were you married?</Label>
            <Input
              type="text"
              placeholder="City, State"
              value={formData.locationOfMarriage}
              onChange={(e) =>
                setFormData({ ...formData, locationOfMarriage: e.target.value })
              }
              required
            />
          </Field>

          {(formData.marriageStatus === "separated" ||
            formData.marriageStatus === "divorced") && (
            <Field>
              <Label>When did you separate?</Label>
              <Input
                type="date"
                value={
                  formData.dateOfSeparation
                    ? formData.dateOfSeparation.toISOString().split("T")[0]
                    : ""
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    dateOfSeparation: e.target.value
                      ? new Date(e.target.value)
                      : undefined,
                  })
                }
                required
              />
            </Field>
          )}

          {formData.marriageStatus === "divorced" && (
            <Field>
              <Label>When was your divorce finalized?</Label>
              <Input
                type="date"
                value={
                  formData.dateOfDivorce
                    ? formData.dateOfDivorce.toISOString().split("T")[0]
                    : ""
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    dateOfDivorce: e.target.value
                      ? new Date(e.target.value)
                      : undefined,
                  })
                }
                required
              />
            </Field>
          )}

          <Button type="submit" className="w-full" disabled={!submitEnabled()}>
            Continue
          </Button>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingRelationshipDatesStep;
